<full-calendar [options]="calendarOptions"></full-calendar>


<ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
           <dl>
            <dt>Titre</dt>
            <dd>{{obj?.title}}</dd>
           </dl>


           <dl>
            <dt>Jour</dt>
            <dd>{{obj?.date_name}}</dd>
           </dl>

           <dl>
            <dt>Date début</dt>
            <dd>{{obj?.start | date:"hh:mm:ss"}}</dd>
           </dl>

           <dl>
            <dt>Date de fin</dt>
            <dd>{{obj?.end | date:"hh:mm:ss"}}</dd>
           </dl>
      </div>
</ng-template>
